import { useFormik } from "formik";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { CartTotal } from "../../../../Common/Components/CartTotal";
import { ConfirmationModal } from "../../../../Common/Components/ConfirmationModal";
import LaundryItemCard from "../../../../Common/Components/LaundryItemCard";
import ServicePicker from "../../../../Common/Components/ServicePicker";
import { TitleHeader } from "../../../../Common/Components/TitleHeader";
import useCartTotal from "../../../../Common/Hooks/useCartTotal";
import {
  calculateBundleOffer,
  getBundleMessage,
} from "../../../../Services/CartService";
import {
  fetchLaundryItem,
  fetchServices,
  fetchOrderDetails as fetchStoreOrderDetails,
} from "../../../Services/OrderService";

export const OrderEdit = () => {
  const [services, setServices] = React.useState([]);
  const [categories, setCategories] = React.useState([]);
  const [initLoading, setInitLoading] = React.useState(true);
  const [itemsLoading, setItemsLoading] = React.useState(false);
  const [laundryItems, setLaundryItem] = React.useState([]);
  const [campaign, setCampaign] = React.useState(null);
  const [payload, setPayload] = React.useState({
    serviceId: null,
    categoryId: null,
    limit: 100,
    offset: 1,
  });
  const [cShow, setCShow] = React.useState(false);
  const lastService = useSelector((x) => x.Service);
  const lastCategory = useSelector((x) => x.Category);
  const cart = useSelector((x) => x.Cart);
  const orderTypeId = useSelector((x) => x.OrderTypeId);
  const bookingType = useSelector((x) => x.BookingType);
  const config = useSelector((x) => x.Config);
  const [reload, setReload] = React.useState("");
  const [amount, total] = useCartTotal();
  const [tempServ, setTempServ] = React.useState(null);
  const [tempBook, setTempBook] = React.useState(null);
  const [zoneId, setZoneId] = React.useState(2);
  const [order, setOrder] = React.useState(null);
  const params = useParams();
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      cart: {
        items: [],
      },
    },
  });

  React.useEffect(() => {
    if (params?.id)
      fetchStoreOrderDetails(params?.id).then(
        (res) => {
          const data = res.data;
          // console.log(data);
          if (data) {
            setOrder(data);
            setZoneId(data.zone_id);
            dispatch({
              type: "setOrderType",
              payload: data.delivery_type?.title?.toLowerCase()?.trim(),
            });
            dispatch({
              type: "setOrderTypeId",
              payload: data.delivery_type?.id,
            });
            dispatch({
              type: "setBookingType",
              payload: data.booking_type,
            });
            dispatch({
              type: "setSelfPick",
              payload: !Boolean(data.is_hub_store),
            });
          }
        },
        (er) => {
          console.warn(er);
          toast.error("Something went wrong while fetching order details.");
        }
      );
  }, [params, dispatch]);
  React.useEffect(() => {
    if (order && (!cart || cart.length === 0)) {
      const arr = [];
      console.log(order);

      order.details.forEach((x) => {
        console.log("--order item", x);
        const newPrice =
          order.booking_type == 2
            ? typeof x.laundry_item?.services[0].pivot.e_price == "string"
              ? parseFloat(x.laundry_item?.services[0].pivot.e_price)
              : x.laundry_item?.services[0].pivot.e_price
            : typeof x.laundry_item?.services[0].pivot.price == "string"
            ? parseFloat(x.laundry_item?.services[0].pivot.price)
            : x.laundry_item?.services[0].pivot.price;

        const payload = {
          details_id: x.id, // to be changed
          laundry_item_id: x.laundry_item_id,
          laundry_item_category_id: x.laundry_item?.laundry_item_category_id,
          price: newPrice,
          actualPrice: newPrice,
          quantity: x.quantity,
          name: x.laundry_item?.name,
          serviceId: x.laundry_item?.services[0]?.id,
          is_bundle_active: Boolean(x.is_bundle_active),
          bundle_buy: x.bundle_buy,
          bundle_free: x.bundle_free,
          free_items:
            x.bundle_buy > 0
              ? calculateBundleOffer({
                  totalQuantity: x.quantity,
                  bundleBuy: x.bundle_buy,
                  bundleFree: x.bundle_free,
                  itemPrice: newPrice,
                }).freeItems
              : 0,
          addons: x.laundry_item?.addons?.map((z) => {
            return {
              id: z.addon_id,
              name: z.addon_name,
              price:
                typeof z.price === "string" ? parseFloat(z.price) : z.price,
              qty: z.qty,
            };
          }),
        };
        arr.push(payload);
      });
      dispatch({ type: "setCart", payload: arr });
    }
  }, [order, cart, dispatch]);

  React.useEffect(() => {
    if (orderTypeId) {
      fetchServices(100, 1, orderTypeId)
        .then((res) =>
          res.filter((x) => {
            if (orderTypeId == 1 || orderTypeId == 2) {
              if (!x.delivery_types) return true;
              else if (x.delivery_types.length == 0) return true;
              else return x.delivery_types.some((y) => y.id == orderTypeId);
            } else return true;
          })
        )
        .then(
          (res) => {
            setServices(res);
            let selectedService;
            if (lastService && lastService !== "null")
              selectedService = res.find((x) => x.id === parseInt(lastService));
            else selectedService = res[0];

            const cats = selectedService?.categories || [];
            setCategories(cats);
            let selectedCategory;
            if (lastCategory && lastCategory !== "null")
              selectedCategory = cats.find(
                (x) => x.id === parseInt(lastCategory)
              );
            else selectedCategory = cats[0];

            setPayload((state) => ({
              ...state,
              serviceId: selectedService?.id,
              categoryId: selectedCategory?.id,
            }));
            setInitLoading(false);
          },
          (er) => {
            console.warn("Something went wrong on services...");
          }
        );
    }
  }, [orderTypeId]);

  React.useEffect(() => {
    if (!initLoading && !itemsLoading) {
      setItemsLoading(true);
      fetchLaundryItem({ ...payload, zoneId }).then(
        (res) => {
          setItemsLoading(false);
          setLaundryItem(res.data);
          setCampaign(res.campain[0]);
          formik.setValues((y) => {
            const payload = {
              ...y,
              cart: {
                ...y.cart,
                items: res.data.map((x) => {
                  const fCart = cart.find(
                    (f) =>
                      f.laundry_item_id === x.id &&
                      f.serviceId === x.services[0]?.id
                  );
                  const newPrice =
                    bookingType == 2
                      ? typeof x.services[0].pivot.e_price == "string"
                        ? parseFloat(x.services[0].pivot.e_price)
                        : x.services[0].pivot.e_price
                      : typeof x.services[0].pivot.price == "string"
                      ? parseFloat(x.services[0].pivot.price)
                      : x.services[0].pivot.price;
                  if (fCart) {
                    const fitems = calculateBundleOffer({
                      totalQuantity: fCart.quantity,
                      bundleBuy: x.bundle_offer?.required_items,
                      bundleFree: x.bundle_offer?.total_discount_items,
                      itemPrice: newPrice,
                    }).freeItems;
                    const fadb9 = {
                      ...fCart,
                      is_bundle_active: fitems > 0,
                      bundle_buy: x.bundle_offer?.required_items,
                      bundle_free: x.bundle_offer?.total_discount_items,
                      free_items: fitems,
                      addons: x.addons.map((z) => {
                        const fAd = fCart.addons.find(
                          (ffAd) => ffAd.id === z.id
                        );
                        if (fAd) return fAd;
                        else
                          return {
                            id: z.id,
                            name: z.name,
                            price: z.price,
                            qty: 0,
                          };
                      }),
                      price: newPrice,
                      actualPrice: newPrice,
                    };
                    if (res.campain[0]) {
                      fadb9.price =
                        fadb9.price -
                        fadb9.price * (res.campain[0].discount / 100);
                    }
                    return fadb9;
                  } else {
                    const catId = x.laundry_item_category_id;
                    const fadb9 = {
                      details_id: null,
                      laundry_item_id: x.id,
                      laundry_item_category_id:
                        typeof catId === "number" ? catId : parseInt(catId),
                      price: newPrice,
                      actualPrice: newPrice,
                      quantity: 0,
                      name: x.name,
                      serviceId: x.services[0]?.id,
                      is_bundle_active: false,
                      bundle_buy: x.bundle_offer?.required_items,
                      bundle_free: x.bundle_offer?.total_discount_items,
                      free_items: 0,
                      addons: x.addons.map((z) => {
                        return {
                          id: z.id,
                          name: z.name,
                          price: z.price,
                          qty: 0,
                        };
                      }),
                    };
                    if (res.campain[0]) {
                      fadb9.price =
                        fadb9.price -
                        fadb9.price * (res.campain[0].discount / 100);
                    }
                    return fadb9;
                  }
                }),
              },
            };
            return payload;
          });
        },
        (er) => {
          setItemsLoading(false);
          console.warn(er, "error on laundry item.");
        }
      );
    }
  }, [initLoading, payload, reload]);

  React.useEffect(() => {
    if (!initLoading) {
      const items = [...formik.values.cart.items];
      const currentCart = [...cart];
      const newItems = [...items];

      let updatedCart = currentCart.map((item) => {
        const newItem = newItems.find(
          (newItem) =>
            newItem.laundry_item_id === item.laundry_item_id &&
            newItem.serviceId === item.serviceId
        );
        return newItem || item;
      });

      newItems
        .filter((x) => x.quantity !== 0)
        .forEach((newItem) => {
          if (
            !updatedCart.find(
              (item) =>
                item.laundry_item_id === newItem.laundry_item_id &&
                item.serviceId === newItem.serviceId
            )
          ) {
            updatedCart.push(newItem);
          }
        });

      for (let i = 0; i < updatedCart.length; i++) {
        const x = updatedCart[i];
        const y = { ...x, addons: [] };

        if (x.quantity !== 0) {
          for (let j = 0; j < x.addons.length; j++) {
            const z = x.addons[j];
            if (z.qty !== 0) {
              y.addons.push(z);
            }
          }
          // newItems.push(y);
        }
        updatedCart[i] = y;
      }
      updatedCart = updatedCart.filter((x) => x.quantity !== 0);
      // console.clear();
      // // console.log(updatedCart, "modified values from formik....");
      dispatch({ type: "setCart", payload: updatedCart });
    }
  }, [formik.values, initLoading, dispatch]);

  const selectService = (serviceId, clearTemp) => {
    if (
      orderTypeId != 1 &&
      orderTypeId != 2 &&
      serviceId != lastService &&
      total != 0 &&
      !clearTemp
    ) {
      setTempServ(serviceId);
    } else {
      setTempServ(null);
      const serv = services.find((x) => x.id == serviceId);
      const cats = serv.categories;
      setCategories(cats);
      setPayload((state) => ({ ...state, serviceId, categoryId: cats[0]?.id }));
      dispatch({ type: "setService", payload: serviceId });
    }
  };
  const selectCategory = (categoryId) => {
    setPayload((state) => ({ ...state, categoryId }));
    dispatch({ type: "setCategory", payload: categoryId });
  };
  const toggleAddons = (index) => {
    setLaundryItem((prevItems) =>
      prevItems.map((item, i) =>
        i === index ? { ...item, showAddons: !item.showAddons } : item
      )
    );
  };
  const changeItemQuantity = (index, value) => {
    formik.setValues((v) => ({
      cart: {
        items: v.cart.items.map((v, i) => {
          if (i === index) {
            const item = { ...v, quantity: value };
            if (item.bundle_buy > 0)
              item.free_items = calculateBundleOffer({
                totalQuantity: value,
                bundleBuy: item.bundle_buy,
                bundleFree: item.bundle_free,
                itemPrice: item.price,
              }).freeItems;

            item.is_bundle_active = item.free_items > 0;

            return item;
          }
          return v;
        }),
      },
    }));
  };
  const changeAddonQuantity = (itemIndex, addonIndex, qty) => {
    formik.setValues((v) => ({
      cart: {
        items: v.cart.items.map((v, i) =>
          i === itemIndex
            ? {
                ...v,
                addons: v.addons.map((ad, adI) =>
                  addonIndex === adI ? { ...ad, qty } : ad
                ),
              }
            : v
        ),
      },
    }));
  };
  const cCart = (serv, isServ = true) => {
    dispatch({ type: "setCart", payload: [] });
    formik.setValues({ cart: { items: [] } });
    if (isServ && serv) {
      setTimeout(() => {
        selectService(serv, true);
      }, 100);
    }
    if (!isServ && serv) {
    } else {
      dispatch({ type: "setService", payload: null });
      dispatch({ type: "setCategory", payload: null });
      dispatch({ type: "setPickupDate", payload: null });
      dispatch({ type: "setDeliveryDate", payload: null });
      dispatch({ type: "setAddresses", payload: null });
      setReload(Date.now().toString());
    }
  };
  const getLaundryItem = (id) => {
    return laundryItems.find((x) => x.id == id);
  };
  const getOffer = (id) => {
    return getLaundryItem(id)?.bundle_offer;
  };
  const ServicePickerMemo = React.memo(ServicePicker);

  const changeItemNote = (itemIndex, item_note) => {
  formik.setValues((v) => ({
    cart: {
      items: v.cart.items.map((item, i) =>
        i === itemIndex ? { ...item, item_note } : item
      ),
    },
  }));
  };

  return (
    <>
      <TitleHeader
        title={"Select Your Laundry"}
        subtitle={
          "Build your perfect laundry load by selecting your options below!"
        }
      />
      <div className="container">
        {initLoading ? (
          <>
            <div
              className="row justify-content-center align-items-center"
              style={{ height: "50vh" }}
            >
              <div
                className="spinner-border text-warning"
                role="status"
                style={{ width: "3rem", height: "3rem" }}
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </>
        ) : (
          <>
            <ServicePickerMemo
              payload={payload}
              selectService={selectService}
              services={services}
            />
            <div className="row">
              <div
                className="col-12 text-center"
                style={{ marginBottom: "17px" }}
              >
                <span
                  style={{ fontSize: "18px", color: "#656565" }}
                  className="fw-bold"
                >
                  2. Select Category
                </span>
              </div>
            </div>
            <div
              className="row justify-content-start justify-content-md-center column-gap-3 row-gap-3 px-4 select-category-chip-container"
              style={{
                marginBottom: "30px",
                flexWrap: "nowrap",
                width: "100%",
                overflowX: "auto",
              }}
            >
              {categories.map((e) => (
                <div
                  key={`category-id-${e.id}`}
                  className={`select-category-chip ${
                    e.id === payload.categoryId ? "selected" : ""
                  }`}
                  onClick={() => selectCategory(e.id)}
                >
                  {e.name}
                </div>
              ))}
            </div>
            <div className="row justify-content-center pt-4">
              <div className="col-12 text-center">
                <span
                  style={{ fontSize: "18px", color: "#656565" }}
                  className="fw-bold"
                >
                  3. Select your items below
                </span>
              </div>
              <div className="col-lg-10 col-12 my-3">
                <div
                  className={`row px-4 align-items-start justify-content-${
                    formik.values.cart.items?.length === 0
                      ? "center"
                      : "between"
                  }`}
                  style={{ rowGap: "16px" }}
                >
                  {itemsLoading ? (
                    <div className="col-12 text-center">
                      <div
                        className="spinner-border text-warning"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : formik.values.cart.items?.length === 0 ? (
                    <div className="col-auto d-flex align-items-center flex-column py-3">
                      <img
                        src={process.env.PUBLIC_URL + "/assets/images/noitemicon.png"}
                        alt=""
                        style={{ width: "70px" }}
                      />
                      <h6 className="mt-3 mb-0">
                        There are no laundry items in this category...
                      </h6>
                    </div>
                  ) : (
                    formik.values.cart.items?.map((e, itemIndex) => (
                      <LaundryItemCard
                        key={itemIndex}
                        laundryItem={getLaundryItem(e.laundry_item_id)}
                        campaign={campaign}
                        item={e}
                        itemIndex={itemIndex}
                        changeAddonQuantity={changeAddonQuantity}
                        changeItemQuantity={changeItemQuantity}
                        toggleAddons={toggleAddons}
                        offer={getOffer(e.laundry_item_id)}
                        bundleMessage={getBundleMessage(e)}
                        onNoteChange={(item_note) => changeItemNote(itemIndex, item_note)}
                        description={getLaundryItem(e.laundry_item_id)?.description}
                      />
                    ))
                  )}
                </div>
              </div>
            </div>
            <CartTotal />
          </>
        )}
      </div>
      <div className="container-fluid bg-white">
        <div
          className="row justify-content-center"
          style={{ padding: "20px 0px" }}
        >
          <div
            className="d-flex col-lg-6 col-md-7 col-12 justify-content-center flex-column flex-md-row some-random-buttons"
            style={{ columnGap: "20px", rowGap: "10px" }}
          >
            <Link
              to={`/store/orders/edit/summary/${order?.id}`}
              className="service-btn next"
            >
              Next
            </Link>
          </div>
        </div>
      </div>
      <ConfirmationModal
        show={cShow}
        text="Are you sure you want to clear your cart? "
        onNo={() => {
          setCShow(false);
        }}
        onYes={() => {
          setCShow(false);
          cCart();
        }}
      />
      <Modal
        show={tempServ || tempBook}
        onHide={() => {
          setTempServ(null);
          setTempBook(null);
        }}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="text-primary">Warning...</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className="fw-normal text-center">
            You already have {total} item(s) in your cart. If you change{" "}
            {tempBook ? "order type" : "service"} your cart will be cleared.
          </h5>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-between">
          <Button
            variant="primary"
            className="m-0 text-white fw-semibold"
            style={{ width: "49%" }}
            onClick={() => {
              setTempServ(null);
              setTempBook(null);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            className="m-0 bg-dark text-white fw-semibold"
            style={{ width: "49%" }}
            onClick={() => {
              cCart(tempBook || tempServ, !Boolean(tempBook));
            }}
          >
            Change {tempBook ? "order type" : "service"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
